<template>
    <div v-if="owner">
        <div class="row">
            <div class="col-md-12">
                <div class="card card-default">
                    <div v-if="!isModal" class="card-header">
                        <h3 class="card-title custom-card-title"><fa :icon="['fas', 'user']"></fa> {{$t("label.owner_information")}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label for="profile_last_name" class="col-md-4 col-form-label required">{{ $t("label.last_name")}}</label>
                            <div class="col-md-8">
                                <input v-model="owner.last_name" v-validate="'required'" name="profile_last_name" id="profile_last_name" type="text" class="form-control" :placeholder="$t('label.last_name')" />
                                <span v-if="errors.has('profile_last_name')" class="text-danger">
                                    {{ errors.first('profile_last_name')}}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="profile_first_name" class="col-md-4 col-form-label required">{{ $t("label.first_name")}}</label>
                            <div class="col-md-8">
                                <input v-model="owner.first_name" v-validate="'required'" name="profile_first_name" id="profile_first_name" type="text" class="form-control" :placeholder="$t('label.first_name')" />
                                <span v-if="errors.has('profile_first_name')" class="text-danger">
                                    {{ errors.first('profile_first_name')}}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="profile_gender" class="col-md-4 col-form-label required">{{ $t("label.gender")}}</label>
                            <div class="col-md-8">
                                <select v-model="owner.gender" v-validate="'required'" name="profile_gender" id="profile_gender" class="form-control">
                                    <option value="m">{{ $t('label.male') }}</option>
                                    <option value="f">{{ $t('label.female') }}</option>
                                </select>
                                <span v-if="errors.has('profile_gender')" class="text-danger">
                                    {{ errors.first('profile_gender')}}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="profile_nationality" class="col-md-4 col-form-label required">{{ $t("label.nationality")}}</label>
                            <div class="col-md-8">
                                <v-select
                                        v-model="owner.nationality"
                                        name="profile_nationality"
                                        id="profile_nationality"
                                        v-validate="'required'"
                                        :options="countryNames">
                                </v-select>
                                <span v-if="errors.has('profile_nationality')" class="text-danger">
                                    {{ errors.first('profile_nationality')}}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="profile_address" class="col-md-4 col-form-label required">{{ $t("label.address_in_cambodia") }}</label>
                            <div class="col-md-8">
                                <textarea v-model="owner.address" v-validate="'required'" name="profile_address" id="profile_address" class="form-control" :placeholder="$t('label.address_in_cambodia')" rows="3"></textarea>
                                <span v-if="errors.has('profile_address')" class="text-danger">
                                    {{ errors.first('profile_address')}}
                                </span>
                            </div>
                        </div>

                        <!--
                        <div class="form-group row">
                            <input type="hidden" v-model="owner.driver_uuid">
                            <label class="col-md-4 col-form-label">{{ $t("label.owner_also_driver") }}</label>
                            <div class="col-md-8">
                                <label class="col-form-label">{{ $t("label.no") }}</label>
                                &nbsp;
                                <label class="switch">
                                    <input type="checkbox" v-model="is_also_driver">
                                    <span class="slider round"></span>
                                </label>
                                &nbsp;
                                <label class="col-form-label">{{ $t("label.yes") }}</label>
                            </div>
                        </div>
                        -->
                    </div>

                    <div class="card-header">
                        <h3 class="card-title custom-card-title"><fa :icon="['fas', 'id-card']"></fa> {{ $t('label.identity_card')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label for="profile_identity_number" class="col-md-4 col-form-label" :class="{'required' : isPassportInvalid }">{{ $t('label.number') }}</label>
                            <div class="col-md-8">
                                <input v-model="owner.identity_card_number" v-validate="{ required : isPassportInvalid }" name="profile_identity_number" id="profile_identity_number" type="text" class="form-control" :placeholder="$t('label.number')" >
                                <span v-if="errors.has('profile_identity_number')" class="text-danger">
                                    {{ errors.first('profile_identity_number')}}
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isPassportInvalid }">{{ $t('label.issued_date') }}</label>
                            <div class="col-md-8">
                                <datepicker
                                        v-model="owner.identity_card_issued_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        :language="lang"
                                        :disabledDates="{ from: new Date(), to: new Date(1900, 1, 1) }"
                                        format="dd/MM/yyyy"
                                        v-validate="{ required : isPassportInvalid }"
                                        @input="owner.identity_card_expired_date = ''"
                                        name="profile_identity_date" id="profile_identity_date">
                                </datepicker>
                                <span v-if="errors.has('profile_identity_date')" class="text-danger">
                                    {{ errors.first('profile_identity_date')}}
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isPassportInvalid }">{{ $t('label.expired_date') }}</label>
                            <div class="col-md-8">
                                <datepicker
                                        v-model="owner.identity_card_expired_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        :language="lang"
                                        :disabledDates="{ to: new Date(owner.identity_card_issued_date) }"
                                        format="dd/MM/yyyy"
                                        v-validate="{ required : isPassportInvalid }"
                                        name="profile_identity_date_expire"
                                        id="profile_identity_date_expire">
                                </datepicker>
                                <span v-if="errors.has('profile_identity_date_expire')" class="text-danger">
                                    {{ errors.first('profile_identity_date_expire')}}
                                </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isPassportInvalid }">{{ $t('label.identity_card_photo') }}</label>
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.identity_image_front ? $refs.identity_image_front.click() :showImage(owner.identity_image_front)" :class="{ 'is-invalid': errors.has('identity_image_front') }" :style="backgroundStyle('identity_image_front')">
                                            <template v-if="!owner.identity_image_front">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.front_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : isPassportInvalid && !owner.identity_image_front, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="identity_image_front" name="identity_image_front" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('identity_image_front')" class="required">{{ errors.first('identity_image_front')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.identity_image_front !== 'undefined' && owner.identity_image_front !== ''"
                                              @click="$refs.identity_image_front.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.identity_image_back ? $refs.identity_image_back.click() :showImage(owner.identity_image_back)" :class="{ 'is-invalid': errors.has('identity_image_back') }" :style="backgroundStyle('identity_image_back')">
                                            <template v-if="!owner.identity_image_back">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.back_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : isPassportInvalid && !owner.identity_image_back, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="identity_image_back" name="identity_image_back" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('identity_image_back')" class="required">{{ errors.first('identity_image_back')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.identity_image_back !== 'undefined' && owner.identity_image_back !== ''"
                                              @click="$refs.identity_image_back.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-header">
                        <h3 class="card-title custom-card-title"><fa :icon="['fas', 'passport']"></fa> {{ $t('label.passport')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label for="passport_number" class="col-md-4 col-form-label" :class="{'required' : isIdentityInvalid }">{{ $t('label.number') }}</label>
                            <div class="col-md-8">
                                <input v-model="owner.passport_number"
                                       name="passport_number"
                                       v-validate="{ required : isIdentityInvalid }"
                                       :data-vv-as="$t('label.passport_number')"
                                       id="passport_number"
                                       type="text"
                                       class="form-control"
                                       :placeholder="$t('label.number')" />
                                <span v-if="errors.has('passport_number')" class="text-danger">
                                {{ errors.first('passport_number')}}
                            </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isIdentityInvalid }">{{ $t('label.issued_date') }}</label>
                            <div class="col-md-8">
                                <datepicker
                                        v-model="owner.passport_issued_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        :language="lang"
                                        v-validate="{ required : isIdentityInvalid }"
                                        :data-vv-as="$t('label.passport_expired_date')"
                                        :disabledDates="{from: new Date(), to: new Date(1980, 1, 1) }"
                                        @input="owner.passport_expired_date = ''"
                                        format="dd/MM/yyyy"
                                        name="passport_issued_date"
                                        id="passport_issued_date">
                                </datepicker>
                                <span v-if="errors.has('passport_issued_date')" class="text-danger">
                                {{ errors.first('passport_issued_date')}}
                            </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isIdentityInvalid }">{{ $t('label.expired_date') }}</label>
                            <div class="col-md-8">
                                <datepicker
                                        v-model="owner.passport_expired_date"
                                        :bootstrap-styling="true"
                                        :clear-button="true"
                                        :highlighted="highlightedCurrentDate"
                                        :language="lang"
                                        v-validate="{ required : isIdentityInvalid }"
                                        :data-vv-as="$t('label.passport_expired_date')"
                                        :disabledDates="{ to: new Date(owner.passport_issued_date) }"
                                        format="dd/MM/yyyy"
                                        name="passport_expired_date"
                                        id="passport_expired_date">
                                </datepicker>
                                <span v-if="errors.has('passport_expired_date')" class="text-danger">
                                {{ errors.first('passport_expired_date')}}
                            </span>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-md-4 col-form-label" :class="{'required' : isIdentityInvalid }">{{ $t('label.passport_photo') }}</label>
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.passport_image_front ? $refs.passport_image_front.click() :showImage(owner.passport_image_front)" :class="{ 'is-invalid': errors.has('passport_image_front') }" :style="backgroundStyle('passport_image_front')">
                                            <template v-if="!owner.passport_image_front">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.front_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : isIdentityInvalid && !owner.passport_image_front, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="passport_image_front" name="passport_image_front" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('passport_image_front')" class="required">{{ errors.first('passport_image_front')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.passport_image_front !== 'undefined' && owner.passport_image_front !== ''"
                                              @click="$refs.passport_image_front.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.passport_image_back ? $refs.passport_image_back.click() :showImage(owner.passport_image_back)" :class="{ 'is-invalid': errors.has('passport_image_back') }" :style="backgroundStyle('passport_image_back')">
                                            <template v-if="!owner.passport_image_back">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.back_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : isIdentityInvalid && !owner.passport_image_back, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="passport_image_back" name="passport_image_back" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('passport_image_back')" class="required">{{ errors.first('passport_image_back')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.passport_image_back !== 'undefined' && owner.passport_image_back !== ''"
                                              @click="$refs.passport_image_back.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="card-header" v-if="is_also_driver">
                        <h3 class="card-title custom-card-title"><fa :icon="['fas', 'file-alt']"></fa> {{ $t('label.attachment')}}</h3>
                    </div>
                    <div class="card-body" v-if="is_also_driver">
                        <div class="form-group row">
                            <label class="col-md-4 col-form-label required">{{$t('label.driving_license_photo')}}</label>
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.driving_license_image_front ? $refs.driving_license_image_front.click() :showImage(owner.driving_license_image_front)" :class="{ 'is-invalid': errors.has('driving_license_image_front') }" :style="backgroundStyle('driving_license_image_front')">
                                            <template v-if="!owner.driving_license_image_front">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.front_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : is_also_driver && !owner.driving_license_image_front, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="driving_license_image_front" name="driving_license_image_front" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('driving_license_image_front')" class="required">{{ errors.first('driving_license_image_front')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.driving_license_image_front !== 'undefined' && owner.driving_license_image_front !== ''"
                                              @click="$refs.driving_license_image_front.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                    <div class="col-6">
                                        <a href="#" class="imageupload" @click.prevent="!owner.driving_license_image_back ? $refs.driving_license_image_back.click() :showImage(owner.driving_license_image_back)" :class="{ 'is-invalid': errors.has('driving_license_image_back') }" :style="backgroundStyle('driving_license_image_back')">
                                            <template v-if="!owner.driving_license_image_back">
                                                <fa :icon="['fas', 'image']"></fa><br>
                                                {{$t('label.back_side')}}
                                            </template>
                                        </a>
                                        <input type="file" v-validate="{required : is_also_driver && !owner.driving_license_image_back, size:10240 ,ext : ['jpeg','png','jpg']}" class="d-none" ref="driving_license_image_back" name="driving_license_image_back" accept="image/x-png,image/gif,image/jpeg" @change="previewFiles">
                                        <span v-if="errors.has('driving_license_image_back')" class="required">{{ errors.first('driving_license_image_back')}}</span><br/>
                                        <span class="text-success cursor-pointer"
                                              v-if="typeof owner.driving_license_image_back !== 'undefined' && owner.driving_license_image_back !== ''"
                                              @click="$refs.driving_license_image_back.click()"
                                        >{{ $t('label.change_image')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row mt-4">
                            <label class="col-md-4 col-form-label">{{ $t('label.other') }}</label>
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-md-6 col-12">
                                        <a class="btn btn-sm btn-secondary" href="#" @click.prevent="$refs.other.click()">
                                            <fa :icon="['fas', 'paperclip']"></fa>
                                            {{$t('label.choose_document')}}
                                        </a>
                                        <input type="file" v-validate="{size:10240 ,ext : ['jpeg','png','jpg','pdf']}" class="d-none" ref="other" name="other" accept="image/x-png,image/gif,image/jpeg,application/pdf" @change="previewFiles">
                                    </div>
                                    <div class="col-md-6 col-12 mt-2">
                                        <span v-if="typeof owner.other !== 'undefined' && owner.other !== ''"
                                              class="text-success cursor-pointer"
                                              @click="showImage(owner.other)"
                                        >{{ $t('label.view_attachment')}}</span>
                                    </div>
                                    <span class="text-muted ml-2 mt-2">{{ $t('label.other_file_criteria')}}</span>
                                    <span v-if="errors.has('other')" class="ml-2 mt-2 required">{{ errors.first('other')}}</span><br/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div v-if="isSetupProfile" class="text-left">
                    <button type="button" class="btn float-left disabled">
                        <fa :icon="fas.faChevronLeft"></fa>
                        {{ $t("label.back")}}
                    </button>
                </div>
                <div v-if="isSetupProfile" class="text-right">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="submitOwner">
                        {{ $t("label.save_continue")}}
                        <fa :icon="fas.faChevronRight"></fa>
                    </button>
                </div>
                <div v-else class="float-right">
                    <button v-if="isModal && !isSetupProfile" type="button" class="btn btn-secondary mr-2" data-dismiss="modal">
                      {{ $t('label.close') }}
                    </button>
                    <button v-if="!isView" type="button" class="btn btn-primary" @click.prevent="submitOwner">
                        {{ $t("label.save")}}
                    </button>
                    <router-link v-else class="btn btn-sm btn-primary" :to="{ name: 'EditOwner', params: { id: owner.uuid }}">
                      <fa :icon="fas.faEdit" /> {{ $t('label.edit') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    export default {
        name: 'Owner',
        props:{
            isSetupProfile: {
                type: Boolean,
                default: false
            },
            isCreateOwner: {
              type: Boolean,
              default: false,
            },
            isView:{
              type: Boolean,
              default: false
            },
            isModal:{
              type: Boolean,
              default: false
            },
        },
        data(){
            return {
                baseURI: "",
                imageBaseUrl: process.env.VUE_APP_BACKEND_API_URL + "/owners/",
                //countries: [],
                is_also_driver : false,
                owner: {},
            }
        },
        watch: {
            "owner.nationality": function(val){
                if(typeof val != 'undefined' && val != '' && val != null){
                    if(this.countries.length > 0){
                        this.owner.nationality_code = this.countries.filter(function(country){
                            return country.name == val;
                        })[0].code;
                    }
                }
            },
        },
        computed: {
            fas() {
              return fas;
            },
            countryNames() {
                return this.countries.map(function(country) {
                    return country.name;
                });
            },
            isIdentityInvalid() {
                return !this.owner.identity_card_number ||
                    !this.owner.identity_card_issued_date ||
                    !this.owner.identity_card_expired_date ||
                    !this.owner.identity_image_front ||
                    !this.owner.identity_image_back;
            },
            isPassportInvalid() {
                return !this.owner.passport_number ||
                    !this.owner.passport_issued_date ||
                    !this.owner.passport_expired_date ||
                    !this.owner.passport_image_front ||
                    !this.owner.passport_image_back;
            },
            countries(){
              return this.$store.getters['reference/countries'];
            }
        },
        mounted () {
            //this.getCountries();
            if(!this.isCreateOwner){
              this.getOwner(this.$route.params.id);
            }
            $(".vdp-datepicker").find("input").css("background-color", "white");
        },
        methods: {
            getFileChange(){
                if(this.is_also_driver === true){
                    if(this.$refs.identity_image_front.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.identity_image_back.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.passport_image_front.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.passport_image_back.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.driving_license_image_front.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.driving_license_image_back.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.other.files[0] !== undefined){
                        return true;
                    }
                    return false;
                }else{
                    if(this.$refs.identity_image_front.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.identity_image_back.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.passport_image_front.files[0] !== undefined){
                        return true;
                    }
                    if(this.$refs.passport_image_back.files[0] !== undefined){
                        return true;
                    }
                }
            },
            submitOwner() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        let url, method = '';
                        if(this.isCreateOwner){
                          url = this.baseURI + 'owners/store';
                          method = 'POST';
                        }else{
                          url = this.baseURI + 'owners/' + this.owner.uuid;
                          method = 'PATCH';
                        }
                        this.owner.is_also_driver = this.is_also_driver;
                        GDCE_Client.requestApi(method, url, this.owner).then(response => {
                            this.uploadImage(response.data.uuid);
                            if(this.isSetupProfile){
                                this.$emit('saveAndContinue', this.is_also_driver);
                            }else if(this.isModal){
                                this.$store.dispatch('application/setOwner', response.data);
                            }
                        }).catch((error)=>{
                          this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: error,
                          });
                        });
                    }
                });
            },
            getCountries() {
                this.$store.state.loading.status = true;
                let url = this.baseURI + 'reference/countries';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.countries = response.data;
                    this.$store.state.loading.status = false;
                }).catch(()=>{});
            },
            getOwner(uuid) {
                this.$store.state.loading.status = true;
                let url = this.baseURI + 'owners/' + (uuid ? uuid : this.owner.uuid);
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.owner = response.data
                    this.owner.other ? this.owner.other : '';
                    if(this.owner.driver_uuid){
                        this.is_also_driver = true;
                    }
                    this.$store.state.loading.status = false;
                }).catch((error)=>{
                  console.warn(error);
                });
            },
            uploadImage(uuid) {
                this.$store.state.loading.status = true;
                let url = this.baseURI + "/owners/" +uuid+ "/upload";
                const formData = new FormData();
                for (const key in this.owner) {
                  formData.set(key, this.owner[key]);
                }
                const config = {
                    headers: { "Content-Type": "multipart/form-data" }
                };
                GDCE_Client.requestApi("POST", url, formData, config)
                    .then(response => {
                        if(response.status){
                          this.$store.state.loading.status = false;
                          this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: this.$t('message.owner_success'),
                            showCloseButton: true,
                            timer: 1500
                          });
                          if(!this.isModal){
                            this.$router.push({ name: "ViewOwner", params:{ id: uuid } });
                          }
                        }
                    }).catch(function(error) {
                      this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: error,
                      });
                    });
            },
            backgroundStyle(item) {
                if (!this.owner[item]) {
                    return '';
                }

                let image
                if(typeof this.owner[item] === 'string'){
                    let path = this.owner[item].split('/');
                    path =  path[2] + '/' + path[3];
                    image = this.imageBaseUrl + path;
                }else{
                    if (this.owner[item].file_path) {
                        image = this.owner[item].file_path
                    } else {
                        image = URL.createObjectURL(this.owner[item])
                    }
                }
                return `background-image:url('${image}');opacity:1;`
            },
            showImage(src) {
                if(typeof src === 'string'){
                    let path = src.split('/');
                    path =  path[2] + '/' + path[3];
                    window.open( this.imageBaseUrl + path);
                }else{
                    let image = URL.createObjectURL(src)
                    window.open(image);
                }
            },
            previewFiles(event) {
                const file = event.target.files[0]
                if (file.type && file.type.indexOf('image') === -1 && file.type.indexOf('pdf') === -1) {
                    return;
                }
                if(typeof this.owner[event.target.name] === 'undefined'){
                    this.$set(this.owner, event.target.name, file)
                }else{
                    this.owner[event.target.name] = file
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    h3.custom-card-title svg{
        font-size: 22px !important;
    }
    .custom-card-title{
        color: #205670;
        text-transform: none !important;
    }
    /* 100% Image Width on Smaller Screens */
    @media only screen and (max-width: 700px) {
        .modal-content {
            width: 100%;
        }
    }

    .imageupload {
        height: 130px;
        position: relative;
        width: 100%;
        background-color: #eeeeee;
        text-align: center;
        border: 1px solid #dddddd;
        -webkit-border-radius: 2px;
        border-radius: 2px;
        opacity: .5;
        font-size: 14px;
        display: block;
        text-decoration: none;
        color: #555555;
        min-height: 100px;
        padding-top: 35px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% auto;

        svg {
            font-size: 26px;
            color: #666666;
        }

        &:hover,
        &.selected {
            opacity: 1;
        }

        &.is-invalid {
            opacity: 1;
            border-color: #dc3545;
            background-color: rgba($color: #dc3545, $alpha: .05);
            color: #dc3545;
        }
    }

    label.required {
        &::after {
            content: " *";
            color: red;
        }
    }
    span.required {
        color: red;
        font-size: 12px;
    }
</style>